import React, { useEffect, useRef, useState } from 'react';

const ProductionSection = () => {
  const sectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      setScrollProgress(Math.max(0, Math.min(1, 1 - (rect.top / window.innerHeight))));
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section ref={sectionRef} data-testid="awards-section" className="relative py-16 flex items-center justify-center bg-slate-950 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950" />
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-6" style={{ opacity: scrollProgress, transform: `translateY(${(1 - scrollProgress) * 30}px)` }}>
            <h3 className="text-lg font-bold text-blue-400 tracking-[0.3em] mb-3">AWARDS & RECOGNITION</h3>
            <h2 className="text-4xl font-black text-white mb-2">MEDICAL INVENTI</h2>
            <p className="text-slate-400 text-sm mt-2">Top Biomaterials Processing Company</p>
            <p className="text-blue-400 text-sm font-semibold">Europe 2024 &bull; Life Sciences Review</p>
          </div>
          <div className="flex justify-center mb-8" style={{ opacity: scrollProgress, transform: `scale(${0.8 + scrollProgress * 0.2})` }}>
            {[...Array(5)].map((_, i) => (
              <svg key={i} className="w-6 h-6 text-blue-400 fill-current" viewBox="0 0 20 20">
                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
              </svg>
            ))}
          </div>
          <div className="flex justify-center items-center mb-8">
            <div className="max-w-2xl w-full rounded-2xl overflow-hidden shadow-2xl relative" style={{ transform: `scale(${0.9 + scrollProgress * 0.1})`, opacity: scrollProgress }}>
              <img src="/medical-inventi-award.png" alt="Medical Inventi Award — Top Biomaterials Processing Company Europe 2024 for FlexiOss bone regenerative material" className="w-full h-auto object-contain" loading="lazy" />
            </div>
          </div>
          <div className="text-center max-w-3xl mx-auto" style={{ opacity: scrollProgress, transform: `translateY(${(1 - scrollProgress) * 20}px)` }}>
            <p className="text-2xl font-bold text-white leading-relaxed italic">"FLEXIOSS WAS SUPPOSED TO LAUNCH QUIETLY... LOOKS LIKE INNOVATION NEVER STAYS SILENT!"</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductionSection;
